import { IkeFieldType } from '@ikegps/core-api';
import type { FormModelField } from '../../form/form.field';
import { CollectionModelField, ModelMutator } from '../collection.field';
import { registerFieldType } from './field.registry';

export interface ModelFieldStateFileTool {
	filename?: string;
	attachmentId?: string;
	size?: number;
	metadata?: {};
}

export class ModelMutatorFileTool extends ModelMutator<FormModelField, CollectionModelFieldFileTool> {
	manual(newFileTool: ModelFieldStateFileTool) {
		if (newFileTool == null) {
			this.state.setFieldValue<ModelFieldStateFileTool>(this.field.id, null);
		} else {
			this.state.setFieldValue<ModelFieldStateFileTool>(this.field.id, {
				filename: newFileTool.filename,
				attachmentId: newFileTool.attachmentId,
				size: newFileTool.size,
				metadata: newFileTool.metadata,
			});
		}
	}

	override copy(from: CollectionModelFieldFileTool): boolean {
		return false;
	}
}
export class CollectionModelFieldFileTool extends CollectionModelField<FormModelField, ModelFieldStateFileTool> {
	static TYPE: IkeFieldType = IkeFieldType.FILE_TOOL;
	static isFileToolField(f: CollectionModelField): f is CollectionModelFieldFileTool {
		return f.schema.type === CollectionModelFieldFileTool.TYPE;
	}

	private _Mutator: ModelMutatorFileTool;
	get Mutator() {
		if (this._Mutator == null) {
			this._Mutator = new ModelMutatorFileTool(this);
		}
		return this._Mutator;
	}

	override get value() {
		const stateValue = this.stateValue;
		if (stateValue == null) {
			return null;
		}

		return this.stateValue.filename;
	}

	override get displayValue() {
		const stateValue = this.stateValue;
		if (stateValue == null) {
			return null;
		}

		return this.stateValue.filename;
	}

	get attachmentId() {
		const stateValue = this.stateValue;
		if (stateValue == null) {
			return null;
		}

		return this.stateValue.attachmentId;
	}

	get size() {
		const stateValue = this.stateValue;
		if (stateValue == null) {
			return null;
		}

		return this.stateValue.size;
	}

	get metadata() {
		const stateValue = this.stateValue;
		if (stateValue == null) {
			return null;
		}

		return this.stateValue.metadata;
	}

	hasValue() {
		const value = this.value;
		if (value == null || value === '') {
			return false;
		}
		return true;
	}
}

registerFieldType(IkeFieldType.FILE_TOOL, (parent, schema) => new CollectionModelFieldFileTool(parent, schema));
